import { useConfigContext } from '../../context/config'

export default function Convert(props) {
  const { className, value = 0 } = props

  const { convertPknAmount } = useConfigContext()

  return <div className={`text-xs whitespace-nowrap ${className}`}>~${convertPknAmount(value)}</div>
}
